const Status = {
  "label"   : "Lobby Status",
  "options" : ["Open", "Closed"]
}

export default Status